import { arFormulaTargetFieldSegments } from '../arTableFormulaEngine';
import type { ArCellValue, TypeId } from '../System.Artifacts.types';

/**
 * formDeriveProjectionColumnWrites
 *
 * Where one declared projection column lands on a row document, as literal path
 * segments. The single spelling of that rule: `computeFormDerives` folds these
 * onto its in-memory row copy, and `reconcileFormDerives` turns the same
 * segments into Firestore `FieldPath`s. A second spelling on either side is a
 * silent divergence, because both sides would still write a real path.
 *
 * A dotted column takes `arFormulaTargetFieldSegments`' composite path verbatim,
 * so the value lands exactly where `readArStoredFormulaResult` looks for it, and
 * it carries no `_calculated` write: the marker is per cell, and the composite
 * parent may hold sub-fields this entry never declared. An undotted column lands
 * on the cell's own `value` — never the formula engine's `calcInput` slot, which
 * no derive owns — and claims the cell with `_calculated`.
 */
type FormDeriveProjectionColumnWrite = {
  /** Literal segments from the row document root; never a joined dotted string. */
  segments: string[];
  value: unknown;
};

function formDeriveProjectionColumnWrites(
  typeId: TypeId,
  value: ArCellValue,
): FormDeriveProjectionColumnWrite[] {
  return typeId.includes('.')
    ? [{ segments: arFormulaTargetFieldSegments(typeId), value }]
    : [
        { segments: ['cells', typeId, 'value'], value },
        { segments: ['cells', typeId, '_calculated'], value: true },
      ];
}

export { formDeriveProjectionColumnWrites };
export type { FormDeriveProjectionColumnWrite };
